import IndustryWiseStatistics from "./QuickLinks&Industry/Statistics";
import LoginHistoryStatistics from "./LoginHistory/LoginHistoryStatistics";
import MemberStatistics from "./MemberStatistics/MemberStatistics";
import MemberWiseTables from "./MembersWiseTables/Tables";
import PendingMembers from "./PendingMember/Members";
import YearWiseMemberCount from "./YearWiseMemberCount/TabsList";
import GeneralCard from "./GeneralCard";
import Error401 from "pages/maintenance/401";
import Loader from "components/Loader";
import useAuth from "hooks/useAuth";

const Dashboard = () => {
  const { modules, isInitialized } = useAuth();

  if (!isInitialized || !modules) {
    return <Loader />;
  }

  if (!modules?.dashboard?.permissions?.View) {
    return <Error401 />;
  }

  return (
    <>
      <GeneralCard />
      <MemberStatistics />
      <YearWiseMemberCount />
      <PendingMembers />
      <LoginHistoryStatistics />
      <MemberWiseTables />
      {/* <IndustryWiseStatistics /> */}
    </>
  );
};

export default Dashboard;
